// extracted by mini-css-extract-plugin
module.exports = {"Sentiment":"Sentiment_Sentiment__ACt7i","Heart":"Sentiment_Heart__z1evg"};